<template>
  <div class="form-wrap">
    <label :for="field"> {{ $t(`containers.${textKey}`) }}? </label>
    <div class="cf">
      <label :for="`${field}-yes`" class="template-type">
        <input type="radio" :id="`${field}-yes`" :value="true" v-on="listeners" v-bind="$attrs" :checked="value" />
        {{ $t(`meta.yes`) }}
      </label>

      <label :for="`${field}-no`" class="template-type">
        <input type="radio" :id="`${field}-no`" :value="false" v-on="listeners" v-bind="$attrs" :checked="!value" />
        {{ $t(`meta.no`) }}
      </label>
    </div>
  </div>
</template>

<script>
import { camelCase } from 'lodash'

export default {
  name: 'BooleanRadioField',
  props: {
    field: { type: String, required: true },
    fieldTranslationKey: { type: String, default: '' },
    value: { type: [Boolean, String] },
  },
  methods: {
    normalizeBooleanValue: function (radioValue) {
      // The HTML RFC requires the input[type="radio"] value to be a string.
      return radioValue.toString()
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit('input', this.normalizeBooleanValue(event.target.value))
        },
        change: event => {
          this.$emit('change', this.normalizeBooleanValue(event.target.value))
        },
      }
    },
    textKey() {
      return this.fieldTranslationKey || camelCase(this.field)
    },
  },
}
</script>
